import React from 'react';

const USLLogo = ({ size = 'medium' }) => {
  const sizeClasses = {
    small: { width: '50px', height: '50px' },
    medium: { width: '70px', height: '70px' },
    large: { width: '120px', height: '120px' }
  };

  const currentSize = sizeClasses[size];

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div
        style={{
          width: currentSize.width,
          height: currentSize.height,
          borderRadius: '50%',
          overflow: 'hidden',
          flexShrink: 0,
          filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))'
        }}
      >
        <img
          src="/images/logooo.jpeg"
          alt="Universal Sports Lab Logo"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            display: 'block'
          }}
          onError={(e) => {
            const wrap = e.target.parentElement;
            if (wrap) wrap.style.display = 'none';
            const fallback = wrap?.nextElementSibling;
            if (fallback) fallback.style.display = 'flex';
          }}
        />
      </div>
      <div
        style={{
          display: 'none',
          width: currentSize.width,
          height: currentSize.height,
          backgroundColor: '#FFD700',
          borderRadius: '50%',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#333',
          fontWeight: 'bold',
          fontSize: '16px'
        }}
      >
        USL
      </div>
    </div>
  );
};

export default USLLogo;